<template>
  <a-button type="outline" @click="handleClick">AI 生成题目</a-button>
  <a-drawer
    :visible="visible"
    :width="340"
    unmountOnClose
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <template #title> AI 生成题目</template>
    <a-form
      :model="form"
      auto-label-width
      label-align="left"
      @submit="handleSubmit"
    >
      <a-form-item label="应用id">{{ appId }}</a-form-item>
      <a-form-item field="questionNumber" label="题目数量">
        <a-input-number
          v-model="form.questionNumber"
          max="20"
          min="1"
          placeholder="请输入题目数量"
        />
      </a-form-item>
      <a-form-item field="optionNumber" label="选项数量" max="6" min="1">
        <a-input v-model="form.optionNumber" placeholder="请输入选项数量" />
      </a-form-item>

      <a-form-item>
        <a-space>
          <a-button
            :loading="submitting"
            html-type="submit"
            style="width: 120px"
            type="primary"
            >{{ submitting ? "生成中" : "一键生成" }}
          </a-button>
          <a-button
            :loading="sseSubmitting"
            style="width: 120px"
            @click="handleSubmitSSE()"
            >{{ sseSubmitting ? "生成中" : "实时生成" }}
          </a-button>
        </a-space>
      </a-form-item>
    </a-form>
  </a-drawer>
</template>

<script lang="ts" setup>
import { defineProps, ref, withDefaults } from "vue";
import API from "@/api";
import { aiGenerateQuestionUsingPost } from "@/api/questionController";
import { Message } from "@arco-design/web-vue";

const visible = ref(false);
const submitting = ref(false);
const sseSubmitting = ref(false);

const handleClick = () => {
  visible.value = true;
};
const handleOk = () => {
  visible.value = false;
};
const handleCancel = () => {
  visible.value = false;
};

interface Props {
  appId: string;
  onSuccess?: (result: API.QuestionContentDTO[]) => void;
  onSSESuccess: (result: API.QuestionContentDTO) => void;
  onSSEStart: (event: any) => void;
  onSSEClose: (event: any) => void;
}

const props = withDefaults(defineProps<Props>(), {
  appId: () => {
    return "";
  },
});

const form = ref({
  optionNumber: 2,
  questionNumber: 10,
} as API.AiGenerateQuestionRequest);

/*
 * 提交
 * */
const handleSubmit = async () => {
  if (!props.appId) {
    return;
  }
  submitting.value = true;
  const res = await aiGenerateQuestionUsingPost({
    appId: props.appId as any,
    ...form.value,
  });
  if (res.data.code === 0 && res.data.data) {
    if (props.onSuccess) {
      props.onSuccess(res.data.data);
    } else {
      Message.success("生成题目成功");
    }
    // 关闭抽屉
    handleCancel();
  } else {
    Message.error("操作失败，" + res.data.message);
  }
  submitting.value = false;
};

/*
 * 提交
 * */
const handleSubmitSSE = async () => {
  if (!props.appId) {
    return;
  }
  sseSubmitting.value = true;
  // 创建sse请求
  const eventSource = new EventSource(
    `http://localhost:8101/api/question/ai_generate/sse?appId=${props.appId}&questionNumber=${form.value.questionNumber}&optionNumber=${form.value.optionNumber}`
  );
  // 接收消息
  let first = true;
  eventSource.onmessage = function (event) {
    if (first) {
      props.onSSEStart(event);
      handleCancel();
      first = !first;
    }
    console.log(event.data);
    props.onSSESuccess?.(JSON.parse(event.data));
  };
  // 报错或连接失败触发
  eventSource.onerror = function (event) {
    if (event.eventPhase == EventSource.CLOSED) {
      console.log("关闭连接");
      eventSource.close();
      props.onSSEClose?.(event);
      handleCancel();
    } else {
      eventSource.close();
    }
  };

  sseSubmitting.value = false;
};
</script>
